<template>
  <div :class="['shift-detail-row-text', {column}, noBorder && 'no-border']">
    <div :class="['name', values && 'multi-row']">{{name}}</div>
    <div>
      <div v-if="value" class="value">{{value}}</div>
      <ul class="value" v-if="values">
        <li v-for="(item, i) in values" :key="i"> {{item}} </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>

defineProps<{
  name: string,
  values?: string[],
  value?: string,
  column?: boolean,
  noBorder?: boolean,
}>();

</script>
<style lang="scss">
.shift-detail-row-text {
  width: 100%;
  background-color: var(--pidz-white);
  color: var(--pidz-body-text);
  min-height: 55px;
  display: flex;
  border-bottom: solid 1px var(--pidz-grey-light);
  padding: 17px 24px;

  .name {
    width: 50%;
    font-weight: 700;
    font-size: 14px;
    align-self: center;

    &.multi-row {
      align-self: flex-start;
    }
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  &.column {
    flex-direction: column;

    .name {
      width: 100%;
      margin-bottom: 12px;
    }
    .value {
      width: 100%;
    }
  }
}
</style>
